module.exports = __webpack_public_path__ + "img/pr-8.dbcfae1e.png";